import React from 'react';
import styled from 'styled-components';

const CheckboxWrapper = styled.div`
  position: relative !important;
  display: block !important;
  min-height: 1.5em !important;
  padding-left: 1.5em !important;
  font-size: 16px !important;

  input:focus ~ label{
    &::after {
      box-shadow: 0 0 3px 2px rgba(0, 51, 160, .25);
      border-radius: 3px;
    }
  }

  input:checked ~ label {
    &::after {
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
    }
  }

  input {
    position: absolute;
    left: 0;
    z-index: -1;
    width: 1em;
    height: 1.25em;
    opacity: 0;

    &:checked ~ label::before {
      color: #fff;
      border-color: var(--blue-color);
      background-color: var(--blue-color);
    }
  }

  label {
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    color: #525252;

    &::before {
      position: absolute;
      top: .125em;
      left: -1.75em;
      display: block;
      width: 1.25em;
      height: 1.25em;
      pointer-events: none;
      content: "";
      background-color: #fff;
      border: 2px solid var(--blue-color);
      border-radius: 3px;
      transition: background-color .15s ease-in-out, border-color .15s ease-in-out;
    }

    &::after {
      position: absolute;
      top: .125em;
      left: -1.75em;
      display: block;
      width: 1.25em;
      height: 1.25em;
      content: "";
      background: no-repeat 50%/50% 50%;
    }
  }
`;

function Checkbox(props) {
  const { checked, id, className, onChange, label, ...rest } = props;

  return (
    <CheckboxWrapper className={className}>
      <input id={id} type="checkbox" checked={checked} onChange={onChange} {...rest} />
      <label htmlFor={id}>{label}</label>
    </CheckboxWrapper>
  );
}

export default Checkbox;
